let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { devices } from 'signup-constants/styles/viewports.styles';
export const SignupChatbotStyles = createGlobalStyle(_t || (_t = _`
  @media not ${0} {
    body:has([data-layout="su0004"]) #hubspot-conversations-iframe-wrapper,
    body:has([data-layout="su0004"]) #hubspot-conversations-iframe {
      display: none !important;
    }
  }

  @media ${0} {
    [data-layout="su0004"] ~ #hubspot-conversations-iframe-wrapper,
    [data-layout="su0004"] ~ #hubspot-conversations-iframe {
      position: fixed !important;
      right: 16px !important;
      bottom: 16px !important;
      left: auto !important;
      top: auto !important;
    }
  }
`), devices.desktop, devices.desktop);